import React, { memo } from "react";

// components
import NotificationsTab from "./Notifications/NotificationsTab";
import NotificationsCenter from "./NotificationsCenter/NotificationsCenter";
import EvacuationAccountability from "../SharedComponents/EvacuationAccountability/EvacuationAccountability";
import CamerasDock from "./Cameras/CameraDock";
import SystemHealth from "./SystemHealth/SystemHealth";
import ErrorBoundary from "../ErrorBoundary";
import ZetronCallingPanel from "./CallingPanel/ZetronCallingPanel";
import StatusBoard from "./StatusBoard/StatusBoard";
import UnitsPanel from "./UnitsPanel/UnitsPanel";
import LPRWatchlistPanel from "./LPRWatchlistPanel/LPRWatchlistPanel";
import OnlineUsers from "./OnlineUsers/OnlineUsers";
import DownloadsPanel from "./Downloads/DownloadsPanel";

//Material UI
import Close from "@mui/icons-material/Close";

import PropTypes from "prop-types";
import { getTranslation } from "orion-components/i18n";
import LPRManager from "../SharedComponents/LPRManager/LPRManager";

const propTypes = {
	selectFloorPlanOn: PropTypes.func,
	floorPlansWithFacilityFeed: PropTypes.object
};

const defaultProps = {
	selectFloorPlanOn: () => {},
	floorPlansWithFacilityFeed: null
};

const Dock = ({
	componentState,
	map,
	readOnly,
	dir,
	selectFloorPlanOn,
	floorPlansWithFacilityFeed,
	notifications,
	unitSettings,
	statusBoardApp,
	bottomAlertListEnabled,
	handleClose,
	forReplay
}) => {
	const dialogTitle = value => {
		let title;
		if (value === "Status_board") {
			title = getTranslation("global.dock.statusBoard.title");
		} else if (value === "System_health") {
			title = getTranslation("global.dock.systemHealth.title");
		} else if (value === "Notifications") {
			title = getTranslation("global.dock.notifications.main.title");
		} else if (value === "Notifications_center") {
			title = getTranslation("global.dock.notificationsCenter.title");
		} else if (value === "Units_panel") {
			title = getTranslation("global.dock.unitsPanel.title");
		} else if (value === "LPR_Manager") {
			title = getTranslation("global.dock.lprManager.title");
		} else if (value === "LPR_Watchlist_Panel") {
			title = getTranslation("global.dock.LPRWatchlistPanel.title");
		} else if (value === "Evacuation") {
			title = getTranslation("global.dock.Evacuation.title");
		} else if (value === "Online_Users") {
			title = getTranslation("global.dock.onlineUsers.header");
		} else if (value === "Cameras") {
			title = getTranslation("global.dock.cameras.title");
		} else if (value === "Downloads") {
			title = getTranslation("global.dock.downloads.title");
		} else {
			title = "";
		}
		return (
			<div
				className={dir && dir == "rtl" ? "notification-titleRTL" : "notification-title"}
				style={{ height: 48 }}
			>
				{title}
			</div>
		);
	};

	// TODO: MAKE CONTROLLED AND ADJUST LABEL AND INK BAR STYLES FOR UNSELECTED

	return (
		<div id="sidebar-inner-wrapper" className="cf">
			<ErrorBoundary>
				{componentState.isOpen && (
					<div onClick={handleClose} className="ad-toggle-mobile" data-testid="orion-components-dock-dock-div">
						{dialogTitle(componentState?.tab)}
						<a data-testid="orion-components-dock-dock-a">
							<div className={dir && dir == "rtl" ? "close-ad-textRTL" : "close-ad-text"}>
								<Close sx={{ color: "#FFF", fontSize: 18 }} />
							</div>
						</a>
					</div>
				)}
				{componentState.tab === "Online_Users" && (
					<ErrorBoundary>
						<OnlineUsers />
					</ErrorBoundary>
				)}

				{componentState.tab === "Downloads" && (
					<ErrorBoundary>
						<DownloadsPanel />
					</ErrorBoundary>
				)}

				{componentState.tab === "LPR_Manager" && (
					<ErrorBoundary>
						<LPRManager />
					</ErrorBoundary>
				)}
				{componentState.tab === "LPR_Watchlist_Panel" && (
					<ErrorBoundary>
						<LPRWatchlistPanel />
					</ErrorBoundary>
				)}
				{componentState.tab === "Notifications" && (
					<ErrorBoundary>
						<div className="margin-container">
							<NotificationsTab
								map={map}
								notifications={notifications}
								componentState={componentState}
								selectFloorPlanOn={selectFloorPlanOn}
								floorPlansWithFacilityFeed={floorPlansWithFacilityFeed}
								dir={dir}
								bottomAlertListEnabled={bottomAlertListEnabled}
								forReplay={forReplay}
							/>
						</div>
					</ErrorBoundary>
				)}

				{componentState.tab === "Notifications_center" && (
					<NotificationsCenter notifications={notifications} componentState={componentState} dir={dir} />
				)}
				{componentState.tab === "Evacuation" && (
					<ErrorBoundary>
						<EvacuationAccountability />
					</ErrorBoundary>
				)}

				{componentState.tab === "Cameras" && (
					<ErrorBoundary>
						<CamerasDock
							map={map}
							readOnly={readOnly}
							selectFloorPlanOn={selectFloorPlanOn}
							floorPlansWithFacilityFeed={floorPlansWithFacilityFeed}
						/>
					</ErrorBoundary>
				)}

				{componentState.tab === "System_health" && (
					<ErrorBoundary>
						<SystemHealth />
					</ErrorBoundary>
				)}

				{componentState.tab === "Status_board" && (
					<ErrorBoundary>
						<StatusBoard canManage={statusBoardApp.permissions.includes("manage")} />
					</ErrorBoundary>
				)}

				{componentState.tab === "Units_panel" && (
					<ErrorBoundary>
						<UnitsPanel unitSettings={unitSettings} dir={dir} />
					</ErrorBoundary>
				)}

				{componentState.tab === "Calling_Panel" && (
					<ErrorBoundary>
						<ZetronCallingPanel />
					</ErrorBoundary>
				)}
			</ErrorBoundary>
		</div>
	);
};

Dock.propTypes = propTypes;
Dock.defaultProps = defaultProps;

export default memo(Dock);
